<div class="dot-lottie" #mainEl>
  <canvas></canvas>

</div>
